/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa loan calculator
 *
 */
Intesa.LoanCalculator = function() {

	/**
	 * Local variables
	 *
	 */
	var loan = this;
	var resetString = "-";
	var validPromoResults = true;
	var validStandardResults = true;
	var genericSettings = JSON.parse( $( "#genericSettings" ).val() );
	var regExSeparator = "\\" + genericSettings.separator;
	if( regExSeparator == "\\&nbsp;" ) regExSeparator = "\\ ";
	var regExDecimal = "\\" + genericSettings.decimal;
	if( regExDecimal == "\\&nbsp;" ) regExDecimal = "\\ ";
	var salaryActiveClass = ".active";
	this.activeCalculator = null;
	var callCount = 0 ;  
	var stepAll;
	var stepFirst;
	var stepSecond;
	var stepCount=1;
	var firstLabel;
	var secondLabel;

	/**
	 * Global variables
	 *
	 */
	this.urlParams = {};

	/**
	 * Init component
	 *
	 */
	this.init = function() {
		
		$(document).ready(function () {

			if ($(window).width() <= 768) {

				var inputs = $('.mobile-loan input[data-parsley-max][data-parsley-min]');

				if (inputs && inputs.length > 0) {
					inputs.each(function () {
						var input = $(this);

						input.parsley().on('field:error', function () {
							var buttonToDisable = input.closest(".tab-mobile").find(".btn-primary");
							buttonToDisable.prop('disabled', true);
						});

						input.parsley().on('field:success', function () {
							var buttonToEnable = input.closest(".tab-mobile").find(".btn-primary");
							buttonToEnable.prop('disabled', false);
						});
					});
				}

			} else {

				var inputs = $('.desktop-loan input[data-parsley-max][data-parsley-min]');

				if (inputs && inputs.length > 0) {
					inputs.each(function () {
						var input = $(this);

						input.parsley().on('field:error', function () {
							var buttonToDisable = input.closest(".desktop-loan").find(".btn-primary");
							buttonToDisable.addClass('disabled');
							var buttonToDisable = input.closest(".desktop-loan").find(".btn-secondary");
							buttonToDisable.addClass('disabled');
						});

						input.parsley().on('field:success', function () {
							var buttonToEnable = input.closest(".desktop-loan").find(".btn-primary");
							buttonToEnable.removeClass('disabled');
							var buttonToEnable = input.closest(".desktop-loan").find(".btn-secondary");
							buttonToEnable.removeClass('disabled');
						});
					});
				}

			}

		});

		//Start loan mobile
		if ($("html").attr("data-bank") == "ISPROMANIA") {
			$(document).on("click", ".hero__link > .btn-primary", function () {
				loan.stepProgressBar(undefined);
			})
		} else {
			$(document).on("click", '.js-loan-hero-btn', function () {
				loan.stepProgressBar(undefined);
			});
		}
		$(document).on("click", '.js-your-data-edit-li', function () {
			loan.stepProgressBar(0);
		});

		$(document).on("click", '.js-loan-filter-hero-btn', function () {
			loan.stepProgressBar(undefined,$(this).attr("data-filter"));
		});
		
		
		//Next or back loan mobile
		if ($("html").attr("data-bank") == "VUB") {
			$(document).on("click", ".js-calc-nav-prev", function () {
				loan.stepProgressBar(-1);
			})
			$(document).on("click", ".js-calc-nav-next", function () {
				loan.stepProgressBar(1);
			});
		} else {
			$(document).on("click", '.loanCalculator__mbtn', function () {
				if ($(this).attr('onclick').includes('-1')) {
					loan.stepProgressBar(-1);
				} else {
					loan.stepProgressBar(1);
				}
			});
		}

		// check calculator
		if( !$( "section.com16-18" ).length ) return;

		loan.setVisibleCalculatorAsActive();
		// change callback
		loan.changeCallback();

		// click events
		loan.attachChangeMinAmountClickEvent();

		// get URL query params
		loan.getUrlQueryStringParams();

		// on change borrow amount
		$( document ).on( "change focusin focusout", '*[data-algoritmInput="borrowAmount"]', function( event ) {

			// prevent default
			event.preventDefault();

			// change callback
			loan.changeCallback();

		} );
		
		$(document).on('keyup', 'input[data-algorithm-input="loanDuration"]', function () {
            var slider = $('.rangeslider.rangeslider--2', loan.activeCalculator);
            var index = parseInt(slider.attr('data-slider-index'));
            slider.slider('setValue', $(this).val(), true);
            
            $('*[data-algoritmInput="tenor"]', loan.activeCalculator).trigger("change");
		});

		// on change tenor
		$( document ).on( "change", '*[data-algoritmInput="tenor"]', function( event ) {

			// prevent default
			event.preventDefault();

			// change callback
			loan.changeCallback();

		} );

		// on change salary
		$( document ).on( "click", '*[data-algoritmInput="salary"]', function( event ) {

			// prevent default
			event.preventDefault();

			// change callback
			loan.changeCallback();

		} );

		// calculate action
		$( document ).on( "click", '*[data-algoritmInput="calculateBtn"]', function( event ) {

			// prevent default
			event.preventDefault();

			// change callback
			loan.changeCallback();

		} );

		// on change tab
		$( document ).on( "click", '.js-com16__toggle', function() {

			// change callback
			loan.changeCallback();

		} );

		// reset monthly installment input when tenor is clicked
		if( $( ".increaseHoverEffect" , loan.activeCalculator).length == 2 ) {

			$( ".increaseHoverEffect" , loan.activeCalculator).eq( 0 ).on( "click", function() {

				$( ".increaseHoverEffect", loan.activeCalculator ).eq( 1 ).find( "input" ).val( "" );

			} );

		}
		
		// on calculator change
		$( document ).on( 'click', '.com15__filterItem', function() {
			var id = $( this ).attr( 'data-filter' );
			var width = $(window).width();
			var calculatorResolution = "desktop" ;
			if(width < 768){
				var calculatorResolution = "mobile" ;
			}
			var calculator = $( '.com15__filter[data-filter="' + id + '"]' ).find( '[data-calculator='+calculatorResolution+']');
		//	loan['loanpurpose'] = id;
			loan.setActiveCalculator( calculator );
			loan.changeCallback();
			// click events
			loan.attachChangeMinAmountClickEvent();

			// get URL query params
			loan.getUrlQueryStringParams();
			
			loan.fillInputsWithQueryParams();
		} );
		
		// fix slider buttons
		$( document ).on( "click", '.js-btnMinus', function() { $( '*[data-algoritmInput="tenor"]' , loan.activeCalculator).trigger( "change" ); } );
		$( document ).on( "click", '.js-btnAdd', function() { $( '*[data-algoritmInput="tenor"]' , loan.activeCalculator).trigger( "change" ); } );
		
		
		if ($('input[data-algorithm-input="loanDuration"]', loan.activeCalculator).length > 0){
			$('input[data-algorithm-input="loanDuration"]', loan.activeCalculator).attr("data-parsley-min", loan.tenor.attr( "data-slider-min" ));
	        $('input[data-algorithm-input="loanDuration"]', loan.activeCalculator).attr("data-parsley-max", loan.tenor.attr( "data-slider-max" ) );
	        $('input[data-algorithm-input="loanDuration"]', loan.activeCalculator).val(loan.tenor.val());
		}
        
		// fill inputs with query params
		loan.fillInputsWithQueryParams();
		if ($('input[data-algorithm-input="loanDuration"]', loan.activeCalculator).length > 0){
		$('input[data-algorithm-input="loanDuration"]', loan.activeCalculator).parsley().validate();
		}

	};

	/**
	 * Get Url Query String Params
	 *
	 */
	this.getUrlQueryStringParams = function() {

		// get url
		var currentURL = window.location.href;
			currentURL = currentURL.split('?');

		// get query params
		var queryString = currentURL[1];

		// check query string not empty
		if( queryString !== undefined ) {

			var params = queryString.split('&');

			params.forEach( function( param ) {

				var property = param.split('=');
				var propertyName = property[0];
				var propertyValue = property[1];

				// set loan.urlParams property
				loan.urlParams[propertyName] = propertyValue;

			} );

		}

	};

	/**
	 * Fill Inputs With Query Params
	 *
	 */
	this.fillInputsWithQueryParams = function() {

		var thereAreQueryParams = $.isEmptyObject(loan.urlParams) ? false : true;

		if( thereAreQueryParams ) {

			// set Discount Code
			loan.setDiscountCodeFromQuery();

			// set tab
			loan.setTabFromQuery();

			// set loan amount
			loan.setLoanAmountFromQuery();

			// set tenor
			loan.setTenorFromQuery();

			// calculate output
			loan.changeCallback();

		}

	};

	/**
	 * Set Discount Code From Query
	 *
	 */
	this.setDiscountCodeFromQuery = function() {

		var discountCode = loan.urlParams.discountCode;
		var discountCodeCircle = $( '[data-salary-code="' + discountCode + '"]' , loan.activeCalculator);

		if ( discountCode && discountCodeCircle.length ) {
			
			var checkExist = setInterval(function() {
				console.log("check basket cookie");
				   if (window.intesa.basket_cookie != undefined) {
				      console.log("Exists basket cookie! triggering click");
					  discountCodeCircle.parent().trigger("click");
					  discountCodeCircle.trigger('click');
				      clearInterval(checkExist);
				   } else {
					   console.log("basket cookie not exist after 3 second stopping interval...") ; 
					   if (++ callCount  == 30) { 
						   console.log("interval stopped");
						   clearInterval(checkExist);
					   }						
				   	}
			}, 100);
		}

	};

	/**
	 * Set Loan Amount From Query
	 *
	 */
	this.setLoanAmountFromQuery = function() {

		var loanAmount = loan.urlParams.loanAmount;

		if ( loanAmount && !isNaN( loanAmount ) ) {

			loanAmount = parseInt( loanAmount );
			var loanAmountInput = $( '[data-algoritmInput="borrowAmount"]' , loan.activeCalculator);
			var loanMin = loanAmountInput.attr( 'data-input-min' ) ? parseInt( loanAmountInput.attr( 'data-input-min' ) ) : 0;
			var loanMax = loanAmountInput.attr( 'data-input-max' ) ? parseInt( loanAmountInput.attr( 'data-input-max' ) ) : 100000000000000;

			if( loanAmount >= loanMin && loanAmount <= loanMax ) loanAmountInput.val( loanAmount );

		}

	};

	/**
	 * Set Tenor From Query
	 *
	 */
	this.setTenorFromQuery = function() {

		var tenor = parseInt( loan.urlParams.tenor );

		if ( tenor && !isNaN(tenor) ) {

			// get step value
			var step = $( '[data-algoritminput="tenor"]', loan.activeCalculator ).attr( 'data-slider-step' );
				step = parseInt( step );

			// round tenor based on step
			tenor = tenor - ( tenor % step );

			// set tenor
			var slider = $( '[data-algoritminput="tenor"]', loan.activeCalculator );
			slider.slider( 'setValue', tenor, true );

		}

	};

	/**
	 * Set Tab From Query
	 *
	 */
	this.setTabFromQuery = function() {

		var isDefaultTab = loan.urlParams.isDefault === 'false' ? false : true;
		var isWithoutSalaryTabVisible = $( '[data-tab="without-salary"] > a', loan.activeCalculator ).is(":visible");

		if ( isWithoutSalaryTabVisible && !isDefaultTab ) {

			$( '[data-tab="without-salary"] > a' , loan.activeCalculator).trigger('click');

		}

	};

	/**
	 * Attach Change Min Amount Click Event
	 *
	 */
	this.attachChangeMinAmountClickEvent = function() {

		$( document ).on( 'click', '*[data-trigger-amount-validation]', function() {

			// get values from attributes
			var $this = $( this );
			var min = $this.attr( 'data-min-amount-value');
			var minMessage = $this.attr( 'data-min-amount-message');

			var max = $this.attr( 'data-max-amount-value');
			var maxMessage = $this.attr( 'data-max-amount-message');
			
			// set new values
			var borrowInput = $( '[data-algoritminput="borrowAmount"]' , loan.activeCalculator);
			borrowInput.attr( 'data-input-min', min );
			borrowInput.attr( 'data-parsley-min', min );
			borrowInput.attr( 'data-parsley-min-message', minMessage );
			if(max != "" && max != undefined){
				borrowInput.attr( 'data-input-max', max );
				borrowInput.attr( 'data-parsley-max', max );
				borrowInput.attr( 'data-parsley-max-message', maxMessage );
			}
			// validate borrow input
			borrowInput.parsley().validate();

			//update min and max
			loan.updateLoanAmountMinMax($(this));

		} );

	};


	/**
	 * Update Loan Amount Min and Max
	 *
	 */
	this.updateLoanAmountMinMax = function(el) {

		if((el!==null)&&(el!==undefined)&&(el!=="")){

			// get values
			var min = el.attr( 'data-min-amount-formatted' );
			var max = el.attr( 'data-max-amount-formatted' );	
			
			if((min!==undefined)&&(min!=="")){

				if($("[data-loan-min]").length>0){

					$("[data-loan-min]").html(min);

				}

			}

			if((max!==undefined)&&(max!=="")){

				if($("[data-loan-max]", loan.activeCalculator).length>0){

					$("[data-loan-max]", loan.activeCalculator).html(max);

				}

			}			

		}

	};



	/**
	 * Update Share Calculator Link
	 *
	 */
	this.updateShareCalculatorLink = function() {

		// get url without query string
		var currentURL = window.location.href;
			currentURL = currentURL.split('?');
			currentURL = currentURL[0];

		// add standard query params
		var queryParams = '?loanAmount=' + loan.borrowAmountValue + '&tenor=' + loan.tenorValue + '&discountCode=' + loan.salaryInterestRateCode;

		// without salary case
		var isWithoutSalaryTab = $( '[data-tab="without-salary"]' , loan.activeCalculator).hasClass( 'open' );
		if( isWithoutSalaryTab ) queryParams += '&isDefault=false';

		//custom url for data-socialshare
		if ($('[data-socialshare]', loan.activeCalculator).length>0){

			$('[data-socialshare]', loan.activeCalculator).each(function(){

				if ($(this).attr("data-socialshare")=="facebook"){

					$(this).attr("href","https://www.facebook.com/sharer/sharer.php?u="+currentURL + queryParams);

				}
			
				if ($(this).attr("data-socialshare")=="twitter"){

					$(this).attr("href","https://twitter.com/home?status="+currentURL + queryParams);

				}
				
				if ($(this).attr("data-socialshare")=="linkedin"){

					$(this).attr("href","https://www.linkedin.com/sharing/share-offsite/?url="+currentURL + queryParams);

				}

				if ($(this).attr("data-socialshare")=="whatsapp"){

					$(this).attr("href"," https://wa.me/?text="+encodeURIComponent(currentURL) + encodeURIComponent(queryParams));

				}					
				
				if ($(this).attr("data-socialshare")=="mail"){

					$(this).attr("href","mailto:?body="+currentURL + encodeURIComponent(queryParams));

				}				

			});
		}

	};

	/**
	 * Set Active Calculator
	 *
	 */
	this.setActiveCalculator = function( calculator ) {

		loan.activeCalculator = calculator;

	};
	
	
	/**
	 * Set Visible Calculator As Active
	 *
	 */
	this.setVisibleCalculatorAsActive = function() {
		var width = $(window).width();
		var calculatorResolution = "desktop" ;
		if(width < 768){
			var calculatorResolution = "mobile" ;
		}
		var calculators = $( '[data-calculator='+calculatorResolution+']' );
		var calculatorFound = false;

		calculators.each( function() {

			// set visible calculator as active
			if( $(this).is(":visible") ) {

				loan.activeCalculator = $( this );
				calculatorFound = true;

			}

		} );

		// handle no calculator active by default
		if( !calculatorFound ) loan.activeCalculator = $( '[data-calculator='+calculatorResolution+']' ).first();

	};
	
	/**
	 * Change input callback
	 *
	 */
	this.changeCallback = function() {
		
	    var calculatorNavigation = Intesa.CalculatorNavigation.getInstance(loan.activeCalculator);
	    calculatorNavigation.init();
		// disable basket buttons
		$( "*[data-generate-cookie]").attr( "data-enabled", "false" );
		
		// get inputs
		loan.getInputs( salaryActiveClass );

		// check errors
		if( loan.borrowAmount.hasClass( "parsley-error" ) ) return;

		// init output elements
		loan.initOutputElements();

		// calculate
		loan.calculateLoan();

		// show results
		loan.fillOutputElements();

		// enable basket buttons
		$( "*[data-generate-cookie]").removeAttr( "data-enabled" );

		// update share calculator
		loan.updateShareCalculatorLink();

	};
	
	/**
	 * Get step of loan
	 */

	this.getCountFormSteps = function (tabSelected) {
		//prendere l'elenco delle classi mobile-loan e controllare che non abbiano la classe second-part
		var divs=$("[data-filter='" + tabSelected + "']").children(".calculator-mobile").children(".mobile-loan").toArray();

		if(divs == null || divs.length==0){
			divs = $('.mobile-loan > .tab-mobile').toArray();
		}

		var classStop = "second-part-tab";
		var numberOfFilterHeroBtn =	$(".js-loan-filter-hero-btn").length;
		

		
		stepFirst=0;
		stepSecond=0;

		var secondpart=false;

		stepCount = 1;

		var step = 0;
		
		if($("html").attr("data-bank") == "VUB" && $(".js-loan-filter-hero-btn").length>1){

			//prende la classe "FHB- " dell'elemento selezionato ed estrae il numero che lo distingue dagli altri filter-hero-btn
			var order = 0;
			if($('.filters-grouped > .collapsed').length > 0){
				order = $('.filters-grouped > .collapsed').attr('class').split(/\s+/).filter(function (str) { return str.includes('FHB-'); }).toString()[4];
			}
			
			var start = 0;
			var end = 0;
			if(order == 0){
				for(i = 0; i<divs.length; i++){
					end++;
					if($('.mobile-loan > .tab-mobile').toArray()[i].classList.contains('tab-results')){
						break;
					}
				}
				console.log("IF 1: end: "+end+ " order: "+order);
			} else {
				var steps = order;
				for(i = 0; i<divs.length; i++){
					end++;
					if($('.mobile-loan > .tab-mobile').toArray()[i].classList.contains('tab-results')){
						steps--;
						if(steps == 0){
							start = end;
							for(i = 0; i<divs.length; i++){
								end++;
								if($('.mobile-loan > .tab-mobile').toArray()[i].classList.contains('tab-results')){
									break;
								}
							}
							break;
						}
					}
				}
				
				console.log("IF 2: end: "+end+ " order: "+order+ " start: "+start+ "steps: "+steps);
			}

			console.log('start: '+start+" end: "+end+ " order: "+order);
			for (var i = start; i < end; i++) {
				var div = divs[i];

				if (div.classList.contains(classStop)) {
					secondpart=true;
				}

				if(secondpart){
					stepSecond++;
				} else {
					stepFirst++;
				}
			}
		} else if( $("html").attr("data-bank") == "ISPBIH" && $(".js-loan-filter-hero-btn").length>1){

			var indexLoan = 0;
			if($('.filters-grouped > .collapsed').length > 0){
				indexLoan = $('.filters-grouped > .collapsed').attr('class').split(/\s+/).filter(function (str) { return str.includes('FHB-'); }).toString();
				var idLoan = $("."+indexLoan).attr("data-filter");
				
				for(i = 0; i<divs.length; i++){
					var div = divs[i];
					if (div.classList.contains(classStop)) {
						secondpart=true;
					}
					if(secondpart){
						stepSecond++;
					} else {
						stepFirst++;
					}
					if($('[data-filter='+idLoan+'] .mobile-loan > .tab-mobile').toArray()[i].classList.contains('tab-results')){
						break;
					}
				}
			}
			
		} else {

			for (var i = 0; i < divs.length; i++) {
				var div = divs[i];

				if (div.classList.contains(classStop)) {
					secondpart=true;
				}

				if(secondpart){
					stepSecond++;
				} else {
					stepFirst++;
				}
			}
		}

		if(stepSecond==0){
			stepFirst-=1;
			console.log("Steps first "+ stepFirst)
		} else{
			stepSecond-=1;
			console.log("Steps second "+ stepFirst)
		}

		stepAll = stepFirst+stepSecond;

		console.log(stepAll+" "+stepSecond+" "+stepFirst)
	};

	this.setStepLabel = function () {

		firstLabel = document.getElementsByName("titleDialog")[0].getAttribute("data-title-first-step");

		secondLabel = document.getElementsByName("titleDialog")[0].getAttribute("data-title-second-step");
	}

	/**
	 * Move progress bar and step count
	 */
	this.stepProgressBar = function (moveStep, tabSelected) {


		if (moveStep == 0) {
			stepCount=1;
		} else if(moveStep == undefined){
			loan.getCountFormSteps(tabSelected);
			loan.setStepLabel();
		} else{
			stepCount += moveStep;
		}

		var maxSteps;
		var percentage;
		var stepCurrent = stepCount;

		if (stepCount > stepFirst) {
			maxSteps = stepSecond;
			stepCurrent = stepCount - stepFirst;
			var title = secondLabel;
		} else {
			maxSteps = stepFirst;
			var title = firstLabel;
		}

		percentage = Math.ceil(stepCurrent / maxSteps * 100);

		var percentageBarDiv = $('.mobile-loan > .tab-mobile > .loanCalculator > .progress-container');

		percentageBarDiv.html('<div class="progress loanCalculator__progress">		<div class="progress-bar" role="progressbar" aria-valuenow="' + percentage + '" aria-valuemin="0" aria-valuemax="' + percentage + '" style="width: ' + percentage + '%;">			<span class="sr-only">' + percentage + ' Complete</span>		</div>	</div>');

		$('.loanCalculator__step-title').text(stepCurrent + '/' + maxSteps + ' ' + title);
	};

	/* --------------------- */

	/**
	 * Calculate loan
	 *
	 */
	this.calculateLoan = function() {

		// set commons output results
		loan.interestRateResultPromo = number_format( loan.salaryInterestRateValue, genericSettings.decimals_number, genericSettings.decimal_number, genericSettings.separator_number );
		loan.interestRateResultStandard = number_format( loan.standardInterestRateValue, genericSettings.decimals_number, genericSettings.decimal_number, genericSettings.separator_number );
		loan.APRResultPromo = number_format( loan.salaryAPRValue, genericSettings.decimals_number, genericSettings.decimal, genericSettings.separator );
		loan.APRResultStandard = number_format( loan.standardAPRValue, genericSettings.decimals_number, genericSettings.decimal_number, genericSettings.separator_number );

		// log
		console.log( "---------------------" );
		console.log( "FORMULA" );
		console.log( "---------------------" );

		// calculate the scaled interest rate
		loan.scaledInterestRateValuePromo = loan.calculateScaledInterestRate( loan.salaryInterestRateValue );
		loan.scaledInterestRateValueStandard = loan.calculateScaledInterestRate( loan.standardInterestRateValue );

		// log
		console.log( "Scaled Interest Rate Value Promo: " + loan.scaledInterestRateValuePromo + " - " + typeof( loan.scaledInterestRateValuePromo ) );
		console.log( "Scaled Interest Rate Value Sandard: " + loan.scaledInterestRateValueStandard + " - " + typeof( loan.scaledInterestRateValueStandard ) );

		// init local variables
		var loanAmountCalculatedPromo,
			loanAmountCalculatedStandard,
			tenorCalculatedPromo,
			tenorCalculatedStandard;


			tenorCalculatedPromo = tenorCalculatedStandard = loan.tenorValue;
			loanAmountCalculatedPromo = loanAmountCalculatedStandard = loan.borrowAmountValue;

		loan.tenorCalculatedPromo = tenorCalculatedPromo;
		loan.tenorCalculatedStandard = tenorCalculatedStandard;
		loan.loanAmountCalculatedPromo = loanAmountCalculatedPromo;
		loan.loanAmountCalculatedStandard = loanAmountCalculatedStandard;

		// log
		console.log( "Tenor Calculated Value Promo: " + tenorCalculatedPromo + " - " + typeof( tenorCalculatedPromo ) );
		console.log( "Tenor Calculated Value Standard: " + tenorCalculatedStandard + " - " + typeof( tenorCalculatedStandard ) );
		console.log( "Loan Amount Value Promo: " + loanAmountCalculatedPromo + " - " + typeof( loanAmountCalculatedPromo ) );
		console.log( "Loan Amount Value Sandard: " + loanAmountCalculatedStandard + " - " + typeof( loanAmountCalculatedStandard ) );

		// check validity
		if( validPromoResults ) {

			// set partial output results
			loan.loanAmountResultPromo = number_format( loanAmountCalculatedPromo, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );
			loan.tenorResultPromo = number_format( tenorCalculatedPromo, 0, genericSettings.decimal_number, genericSettings.separator_number );

			// calculate the monthly installment only if the tenor is valid and the loan amount is greathen then the minimum given
			if( !isNaN( tenorCalculatedPromo ) && ( loanAmountCalculatedPromo >= loan.borrowAmountMin ) ) {

				// calculate the monthly installment
				loan.monthlyInstallmentValuePromo = loan.calculateMonthlyInstallment( loan.scaledInterestRateValuePromo, loanAmountCalculatedPromo, tenorCalculatedPromo );

				// log
				console.log( "Monthly Installment Value Promo: " + loan.monthlyInstallmentValuePromo + " - " + typeof( loan.monthlyInstallmentValuePromo )  );

				// set partial output results
				loan.monthlyInstallmentResultPromo = number_format( loan.monthlyInstallmentValuePromo, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

				// check monthly valid
				if( !isNaN( loan.monthlyInstallmentValuePromo ) ) {

					// calculate amount to repay
					loan.amountToRepayValuePromo = loan.calculataAmountToRepay( loan.monthlyInstallmentValuePromo, tenorCalculatedPromo );

					// log
					console.log( "Amount to Repay Value Promo: " + loan.amountToRepayValuePromo + " - " + typeof( loan.amountToRepayValuePromo ) );

					// set partial output results
					loan.amountToRepayResultPromo = number_format( loan.amountToRepayValuePromo, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

					// check amount to repay valid
					if( isNaN( loan.amountToRepayValuePromo ) ) validPromoResults = false;

				} else {

					validPromoResults = false;

				}

			} else {

				validPromoResults = false;

			}

		}
		if( validStandardResults ) {

			// set partial output results
			loan.loanAmountResultStandard = number_format( loanAmountCalculatedStandard, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );
			loan.tenorResultStandard = number_format( tenorCalculatedStandard, "0", genericSettings.decimal_number, genericSettings.separator_number );

			// calculate the monthly installment only if the tenor is valid and the loan amount is greathen then the minimum given
			if( !isNaN( tenorCalculatedStandard ) && ( loanAmountCalculatedStandard >= loan.borrowAmountMin ) ) {

				// calculate the monthly installment
				loan.monthlyInstallmentValueStandard = loan.calculateMonthlyInstallment( loan.scaledInterestRateValueStandard, loanAmountCalculatedStandard, tenorCalculatedStandard );

				// log
				console.log( "Monthly Installment Value Standard: " + loan.monthlyInstallmentValueStandard + " - " + typeof( loan.monthlyInstallmentValueStandard )  );

				// set partial output results
				loan.monthlyInstallmentResultStandard = number_format( loan.monthlyInstallmentValueStandard, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

				// check monthly valid
				if( !isNaN( loan.monthlyInstallmentValueStandard ) ) {

					// calculate amount to repay
					loan.amountToRepayValueStandard = loan.calculataAmountToRepay( loan.monthlyInstallmentValueStandard, tenorCalculatedStandard );

					// log
					console.log( "Amount to Repay Value Standard: " + loan.amountToRepayValueStandard + " - " + typeof( loan.amountToRepayValueStandard ) );

					// set partial output results
					loan.amountToRepayResultStandard = number_format( loan.amountToRepayValueStandard, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

					// check amount to repay valid
					if( isNaN( loan.amountToRepayValueStandard ) ) validStandardResults = false;

				} else {

					validStandardResults = false;

				}

			} else {

				validStandardResults = false;

			}

		}

	};

	/**
	 * Calculate Scaled Interest Rate
	 *
	 * @param {*} interestRate
	 */
	this.calculateScaledInterestRate = function( interestRate ) {

		return Number( ( interestRate / 100 ) * ( ( 365 / 360 ) / 12 ) );

	};

	/**
	 * Calculate Monthly Installment
	 *
	 * @param {*} scaledInterestRate
	 * @param {*} borrowAmount
	 * @param {*} tenor
	 */
	this.calculateMonthlyInstallment = function( scaledInterestRate, borrowAmount, tenor ) {

		var monthlyInstallmentFormula = NaN;

		if( ( borrowAmount !== null ) && ( borrowAmount !== "0" ) &&
			( scaledInterestRate !== null ) && ( scaledInterestRate !== "0" ) &&
			( tenor !== null ) && ( tenor !== "0" ) ) {

			if( ( tenor > loan.tenorMax ) ||
			 	( tenor < loan.tenorMin ) ) {

				monthlyInstallmentFormula = NaN;

			} else {

				monthlyInstallmentFormula = Math.round( ( borrowAmount * scaledInterestRate ) / ( 1 - ( 1 / Math.pow( ( 1 + scaledInterestRate ), tenor ) ) ) );
				monthlyInstallmentFormula = monthlyInstallmentFormula.toFixed( 2 );

				// Comment by customer request
				/* if( ( loan.PPIValue !== "" ) && ( loan.PPIValue > 0 ) ) {

					monthlyInstallmentFormula = Math.floor( monthlyInstallmentFormula / ( 1 + loan.PPIValue ) );

				} */

			}

		}

		return Number( monthlyInstallmentFormula );

	};

	/**
	 * Calculate Amount to Repay
	 *
	 * @param {*} monthlyInstallment
	 * @param {*} tenor
	 */
	this.calculataAmountToRepay = function( monthlyInstallment, tenor ) {

		var amountToRepayFormula = NaN;

		if( ( monthlyInstallment !== null ) && ( monthlyInstallment !== "0" ) ) {

			amountToRepayFormula = monthlyInstallment * tenor;

		}

		return Number( amountToRepayFormula );

	};

	/* --------------------- */

	/**
	 * Init output elements
	 *
	 */
	this.initOutputElements = function() {

		loan.setOutputElements();
		loan.resetOutputElements();

	};

	/**
	 * Set output elements
	 *
	 */
	this.setOutputElements = function() {

		loan.setOutputElementsPromo();
		loan.setOutputElementsStandard();

	};

	/**
	 * Set output elements Promo
	 *
	 */
	this.setOutputElementsPromo = function() {

		// promo
		loan.monthlyInstallmentPromo = $( '*[data-algoritmResult="monthlyInstallmentPromo"]', loan.activeCalculator );
		loan.loanAmountPromo = $( '*[data-algoritmResult="loanAmountPromo"]', loan.activeCalculator );
		loan.amountToRepayPromo = $( '*[data-algoritmResult="amountToRepayPromo"]', loan.activeCalculator );
		loan.tenorPromo = $( '*[data-algoritmResult="tenorPromo"]', loan.activeCalculator );
		loan.interestRatePromo = $( '*[data-algoritmResult="interestRatePromo"]', loan.activeCalculator );
		loan.aprPromo = $( '*[data-algoritmResult="aprPromo"]' , loan.activeCalculator);
		loan.getButton = $( "*[data-generate-cookie]");
		loan.callButton = $( "*[data-tab] .com16__buttonCover .call-btn", loan.activeCalculator );

	};

	/**
	 * Set output elements Standard
	 *
	 */
	this.setOutputElementsStandard = function() {

		// standard
		loan.monthlyInstallmentStandard = $( '*[data-algoritmResult="monthlyInstallmentStandard"]' );
		loan.loanAmountStandard = $( '*[data-algoritmResult="loanAmountStandard"]' );
		loan.amountToRepayStandard = $( '*[data-algoritmResult="amountToRepayStandard"]' );
		loan.tenorStandard = $( '*[data-algoritmResult="tenorStandard"]' );
		loan.interestRateStandard = $( '*[data-algoritmResult="interestRateStandard"]' );
		loan.aprStandard = $( '*[data-algoritmResult="aprStandard"]' );

	};

	/**
	 * Reset output elements
	 *
	 */
	this.resetOutputElements = function() {

		loan.resetOutputElementsPromo();
		loan.resetOutputElementsStandard();

	};

	/**
	 * Reset output elements Promo
	 *
	 */
	this.resetOutputElementsPromo = function() {

		validPromoResults = true;

		loan.monthlyInstallmentResultPromo = undefined;
		loan.loanAmountResultPromo = undefined;
		loan.amountToRepayResultPromo = undefined;
		loan.tenorResultPromo = undefined;
		loan.interestRateResultPromo = undefined;
		loan.APRResultPromo = undefined;

		loan.monthlyInstallmentPromo.text( resetString );
		loan.loanAmountPromo.text( resetString );
		loan.amountToRepayPromo.text( resetString );
		loan.tenorPromo.text( resetString );
		loan.interestRatePromo.text( resetString );
		loan.aprPromo.text( resetString );

		loan.toggleShopBtn( loan.getButton, "hide" );
		loan.callButton.show();

	};

	/**
	 * Reset output elements Standard
	 *
	 */
	this.resetOutputElementsStandard = function() {

		validStandardResults = true;

		loan.monthlyInstallmentResultStandard = undefined;
		loan.loanAmountResultStandard = undefined;
		loan.amountToRepayResultStandard = undefined;
		loan.tenorResultStandard = undefined;
		loan.interestRateResultStandard = undefined;
		loan.APRResultStandard = undefined;

		loan.monthlyInstallmentStandard.text( resetString );
		loan.loanAmountStandard.text( resetString );
		loan.amountToRepayStandard.text( resetString );
		loan.tenorStandard.text( resetString );
		loan.interestRateStandard.text( resetString );
		loan.aprStandard.text( resetString );

	};

	/* --------------------- */

	/**
	 * Get inputs
	 *
	 * @param {*} salaryActiveClass
	 */
	this.getInputs = function( salaryActiveClass ) {

		// log
		console.log( "---------------------" );
		console.log( "CALCULATOR INPUTS" );
		console.log( "---------------------" );

		// max amount for online
		loan.maxAmountForOnline = $( '*[data-algoritmInput="maxAmountForOnline"]' , loan.activeCalculator);
		loan.maxAmountForOnlineValue = Number( parseFloat( loan.maxAmountForOnline.val() ) );

		// log
		console.log( "Max Amount for Online Value: " + loan.maxAmountForOnlineValue + " - " + typeof( loan.maxAmountForOnlineValue ) );


		// borrow
		loan.borrowAmount = $( '*[data-algoritmInput="borrowAmount"]' , loan.activeCalculator);
		loan.borrowAmountRoundingValue = Number( parseFloat( loan.borrowAmount.attr( "data-input-rounding" ) ) );
		loan.borrowAmount.val( Number( parseFloat( Math.round( loan.borrowAmount.val().replace( new RegExp( regExSeparator, 'g' ), "" ).replace( new RegExp( regExDecimal, 'g' ), "." ) / loan.borrowAmountRoundingValue ) * loan.borrowAmountRoundingValue ) ) );

		if( $( '*[data-format-currency]', loan.activeCalculator).length ) {

			var cleave = new Cleave( '[data-format-currency]', {

				delimiter: genericSettings.separator,
				numeral: true,
				numeralDecimalMark: genericSettings.decimal,
				numeralDecimalScale: 0,
				numeralThousandsGroupStyle: 'thousand'

			} );

		}

		loan.borrowAmountValue = Number( parseFloat( loan.borrowAmount.val().replace( new RegExp( regExSeparator, 'g' ), "" ).replace( new RegExp( regExDecimal, 'g' ), "." ) ) );
		loan.borrowAmountMin = Number( parseFloat( loan.borrowAmount.attr( "data-input-min" ) ) );
		loan.borrowAmountMax = Number( parseFloat( loan.borrowAmount.attr( "data-input-max" ) ) );
		// loan.borrowAmountStep = Number( parseFloat( loan.borrowAmount.data( "sliderStep" ) ) );

		// log
		console.log( "Borrow Amount Rounding: " + loan.borrowAmountRoundingValue + " - " + typeof( loan.borrowAmountRoundingValue ) );
		console.log( "Borrow Amount Value: " + loan.borrowAmountValue + " - " + typeof( loan.borrowAmountValue ) );
		console.log( "Borrow Amount Min Value: " + loan.borrowAmountMin + " - " + typeof( loan.borrowAmountMin ) );
		console.log( "Borrow Amount Max Value: " + loan.borrowAmountMax + " - " + typeof( loan.borrowAmountMax ) );
		// console.log( "Borrow Amount Step Value: " + loan.borrowAmountStep + " - " + typeof( loan.borrowAmountStep ) );


		// standard interest rate
		loan.standardInterestRate = $( '*[data-algoritmInput="standardInterestRate"]', loan.activeCalculator );
		loan.standardInterestRateValue = Number( parseFloat( loan.standardInterestRate.val() ) );
		loan.standardInterestRateCode = $( '*[data-algoritmInput="standardInterestRateCode"]', loan.activeCalculator ).val();

		// log
		console.log( "Standard Interest Rate Value: " + loan.standardInterestRateValue + " - " + typeof( loan.standardInterestRateValue ) );
		console.log( "Standard Interest Rate Code: " + loan.standardInterestRateCode + " - " + typeof( loan.standardInterestRateCode ) );

		// salary rate
		if( $( '*[data-algoritmInput="salary"]' + salaryActiveClass , loan.activeCalculator).length ) {
			loan.salaryInterestRate = loan.getIRRange();
		}
		
		/* 
		 * old default IR value
		 * loan.salaryInterestRate = $( '[data-algoritminput="standardInterestRate"]' , loan.activeCalculator).val();
		 */

		loan.salaryInterestRateValue = Number( parseFloat( loan.salaryInterestRate.replace( new RegExp( regExDecimal, 'g' ), "." ) ) );
		if(  $( '*[data-algoritmInput="salary"]' + salaryActiveClass , loan.activeCalculator).length ) {
			loan.salaryInterestRateCode = $( '*[data-algoritmInput="salary"]' + salaryActiveClass , loan.activeCalculator).attr( "data-salary-code" );
		} else {
			loan.salaryInterestRateCode = '';
		}


		/* removed special offer ------------------------------
		if( (loan.salaryInterestRateCode === 'AKTIV250' || loan.salaryInterestRateCode === 'AKTIV450') && loan.borrowAmountValue >= 7000000 ) {
			if(loan.salaryInterestRateCode === 'AKTIV450'){
				loan.salaryInterestRate = $("[data-aktiv=AKTIV450]", loan.activeCalculator).val();
			} else if(loan.salaryInterestRateCode === 'AKTIV250') {
				loan.salaryInterestRate = $("[data-aktiv=AKTIV250]", loan.activeCalculator).val();
			}
			loan.salaryInterestRateValue = Number( parseFloat( loan.salaryInterestRate ) );
		}
		*/
		if( loan.borrowAmountValue >= 7000000 ) {

			var options = $( '.loansItem__link[data-salary-rate="7.77"]' , loan.activeCalculator);

			if( options.length ) {

				options.each( function() {

					var $this = $( this );
					
					if($(this).attr("data-salary-code") == "AKTIV450"){
						var atk450 = $("[data-aktiv=AKTIV450]", loan.activeCalculator).val();
						$this.attr( 'data-salary-rate', atk450 );
						$this.attr( 'data-discount', atk450 );
						$this.find( '.discountToApply' ).text( atk450 + "%" );
						
						var data = $this.attr( 'data-layer-push' );
							data = JSON.parse(data);
	
						// update attribute data
						data.evtLabel = 'Personal Loan'+atk450+'% interest';
						
					} else if($(this).attr("data-salary-code") == "AKTIV250"){
						var atk250 = $("[data-aktiv=AKTIV250]", loan.activeCalculator).val();
						$this.attr( 'data-salary-rate', atk250 );
						$this.attr( 'data-discount', atk250 );
						$this.find( '.discountToApply' ).text( atk250+"%" );
						
						var data = $this.attr( 'data-layer-push' );
							data = JSON.parse(data);
	
						// update attribute data
						data.evtLabel = 'Personal Loan'+atk250+'% interest';
					}
					data = JSON.stringify(data);
					$this.attr( 'data-layer-push', data );

				} );

			}

		}
		var atk450 = $("[data-aktiv=AKTIV450]", loan.activeCalculator).val();
		if( $( '.itemActive[data-salary-rate="'+atk450+'"]' , loan.activeCalculator).length ) {
			$( '.cart__summary__item--salary' , loan.activeCalculator).attr( 'data-salarydiscount', atk450 );
			$( '.cart__summary__item--salary .cart__summary__item__number' , loan.activeCalculator).text( atk450 + "%" );
		}
		// ----------------------------------------------------------------------


		// log
		console.log( "Salary Interest Rate Value: " + loan.salaryInterestRateValue + " - " + typeof( loan.salaryInterestRateValue ) );
		console.log( "Salary Interest Rate Code: " + loan.salaryInterestRateCode + " - " + typeof( loan.salaryInterestRateCode ) );


		// standard APR
		loan.standardAPR = $( '*[data-algoritmInput="standardAPR"]' , loan.activeCalculator);
		loan.standardAPRValue = Number( parseFloat( loan.standardAPR.val() ) );

		// log
		console.log( "Standard APR Value: " + loan.standardAPRValue + " - " + typeof( loan.standardAPRValue ) );

		// salary APR
		if( $( '*[data-algoritmInput="salary"]' + salaryActiveClass , loan.activeCalculator).length ) {
			loan.salaryAPR = loan.getAPRRange();
		}
		
		/*
		 * old default APR value
		 * loan.salaryAPR = $( '*[data-algoritmInput="standardAPR"]' , loan.activeCalculator).val();
		 */
		
		loan.salaryAPRValue = Number( parseFloat( loan.salaryAPR ) );


		/* removed special offer ------------------------------
		var atk250APR = $("[data-aktiv=AKTIV250APR]", loan.activeCalculator).val();
		var atk450APR = $("[data-aktiv=AKTIV450APR]", loan.activeCalculator).val();
		if( loan.salaryInterestRateCode === 'AKTIV250' && loan.borrowAmountValue >= 7000000 ) {
			loan.salaryAPR = atk250APR;
			loan.salaryAPRValue = Number( parseFloat( loan.salaryAPR ) );
		}
		if( loan.salaryInterestRateCode === 'AKTIV450' && loan.borrowAmountValue >= 7000000 ) {
			loan.salaryAPR = atk450APR;
			loan.salaryAPRValue = Number( parseFloat( loan.salaryAPR ) );
		}
		*/

		// log
		console.log( "Salary APR Value: " + loan.salaryAPRValue + " - " + typeof( loan.salaryAPRValue ) );

		// PPI
		// Comment by customer request
		/* loan.PPI = $( '*[data-algoritmInput="standardPPI"]' );
		loan.PPIValue = Number( parseFloat( loan.PPI.val() ) );

		// log
		console.log( "PPI Value: " + loan.PPIValue + " - " + typeof( loan.PPIValue ) ); */

		// max amount for online
		loan.maxAmountForOnline = $( '*[data-algoritmInput="maxAmountForOnline"]' , loan.activeCalculator);
		loan.maxAmountForOnlineValue = Number( parseFloat( loan.maxAmountForOnline.val() ) );

		// log
		console.log( "Max Amount for Online Value: " + loan.maxAmountForOnlineValue + " - " + typeof( loan.maxAmountForOnlineValue ) );

		// borrow
		loan.borrowAmount = $( '*[data-algoritmInput="borrowAmount"]' , loan.activeCalculator);
		loan.borrowAmountRoundingValue = Number( parseFloat( loan.borrowAmount.attr( "data-input-rounding" ) ) );
		loan.borrowAmount.val( Number( parseFloat( Math.round( loan.borrowAmount.val().replace( new RegExp( regExSeparator, 'g' ), "" ).replace( new RegExp( regExDecimal, 'g' ), "." ) / loan.borrowAmountRoundingValue ) * loan.borrowAmountRoundingValue ) ) );

		// format currency inputs
		loan.formatMoneyInputs();

		loan.borrowAmountValue = Number( parseFloat( loan.borrowAmount.val().replace( new RegExp( regExSeparator, 'g' ), "" ).replace( new RegExp( regExDecimal, 'g' ), "." ) ) );
		loan.borrowAmountMin = Number( parseFloat( loan.borrowAmount.attr( "data-input-min" ) ) );
		loan.borrowAmountMax = Number( parseFloat( loan.borrowAmount.attr( "data-input-max" ) ) );
		// loan.borrowAmountStep = Number( parseFloat( loan.borrowAmount.data( "sliderStep" ) ) );

		// log
		console.log( "Borrow Amount Rounding: " + loan.borrowAmountRoundingValue + " - " + typeof( loan.borrowAmountRoundingValue ) );
		console.log( "Borrow Amount Value: " + loan.borrowAmountValue + " - " + typeof( loan.borrowAmountValue ) );
		console.log( "Borrow Amount Min Value: " + loan.borrowAmountMin + " - " + typeof( loan.borrowAmountMin ) );
		console.log( "Borrow Amount Max Value: " + loan.borrowAmountMax + " - " + typeof( loan.borrowAmountMax ) );
		// console.log( "Borrow Amount Step Value: " + loan.borrowAmountStep + " - " + typeof( loan.borrowAmountStep ) );

		// tenor
		loan.tenor = $( '*[data-algoritmInput="tenor"]' , loan.activeCalculator);
		loan.tenorValue = Number( loan.tenor.val() );
		loan.tenorMin = Number( loan.tenor.attr( "data-slider-min" ) );
		loan.tenorMax = Number( loan.tenor.attr( "data-slider-max" ) );
		loan.tenorStep = Number( loan.tenor.attr( "data-slider-step" ) );

		// log
		console.log( "Tenor Value: " + loan.tenorValue + " - " + typeof( loan.tenorValue ) );
		console.log( "Tenor Min Value: " + loan.tenorMin + " - " + typeof( loan.tenorMin ) );
		console.log( "Tenor Max Value: " + loan.tenorMax + " - " + typeof( loan.tenorMax ) );
		console.log( "Tenor Step Value: " + loan.tenorStep + " - " + typeof( loan.tenorStep ) );

	};

	/* --------------------- */

	/**
	 * Format Money Inputs
	 *
	 */
	this.formatMoneyInputs = function() {

		var inputToFormat = $( '*[data-format-currency]' , loan.activeCalculator);

		if( inputToFormat.length ) {

			inputToFormat.each( function() {

				var cleave = new Cleave( $(this), {

					delimiter: genericSettings.separator,
					numeral: true,
					numeralDecimalMark: genericSettings.decimal,
					numeralDecimalScale: 0,
					numeralThousandsGroupStyle: 'thousand'

				} );

			} );

		}

	};

	/**
	 * Fill output elements
	 *
	 */
	this.fillOutputElements = function() {

		loan.fillOutputElementsPromo();
		loan.fillOutputElementsStandard();

	};

	/**
	 * Fill output elements Promo
	 *
	 */
	this.fillOutputElementsPromo = function() {

		if( validPromoResults ) {

			loan.interestRatePromo.text( loan.interestRateResultPromo );
			loan.aprPromo.text( loan.APRResultPromo );
			loan.loanAmountPromo.text( loan.loanAmountResultPromo );
			loan.tenorPromo.text( loan.tenorResultPromo );
			loan.monthlyInstallmentPromo.text( loan.monthlyInstallmentResultPromo );
			loan.amountToRepayPromo.text( loan.amountToRepayResultPromo );

			// update basket cookie
			loan.updateBasketCookie();

			// check max borrow amount
			if( loan.loanAmountCalculatedPromo > loan.maxAmountForOnlineValue ) {

				loan.toggleShopBtn( loan.getButton, "hide" );
				loan.callButton.show();

			} else {

				loan.toggleShopBtn( loan.getButton, "show" );
				loan.callButton.hide();

			}

		} else loan.resetOutputElementsPromo();

	};

	/**
	 * Fill output elements Standard
	 *
	 */
	this.fillOutputElementsStandard = function() {

		// show results
		if( validStandardResults ) {

			loan.interestRateStandard.text( loan.interestRateResultStandard );
			loan.aprStandard.text( loan.APRResultStandard );
			loan.loanAmountStandard.text( loan.loanAmountResultStandard );
			loan.tenorStandard.text( loan.tenorResultStandard );
			loan.monthlyInstallmentStandard.text( loan.monthlyInstallmentResultStandard );
			loan.amountToRepayStandard.text( loan.amountToRepayResultStandard );

		} else loan.resetOutputElementsStandard();

	};

	/* --------------------- */
	
	/**
	 * Get APR from dynamic borrowAmount
	 * 
	 */
	
	this.getAPRRange = function () {
		
		var cmd = 0;
		
		if (parseInt(loan.borrowAmountValue) >=0 && parseInt(loan.borrowAmountValue) < 3000000){
			cmd = $( '*[data-algoritmInput="salary"]' + salaryActiveClass , loan.activeCalculator).attr( "data-salary-apr-u3" );
		}else if (parseInt(loan.borrowAmountValue) >= 3000000 && parseInt(loan.borrowAmountValue) < 7000000){
			cmd = $( '*[data-algoritmInput="salary"]' + salaryActiveClass , loan.activeCalculator).attr( "data-salary-apr-o3-u7" );
		}else {
			cmd = $( '*[data-algoritmInput="salary"]' + salaryActiveClass , loan.activeCalculator).attr( "data-salary-apr-o7" );
		}
		
		return cmd;
	}
	
	/* --------------------- */
	
	/**
	 * Get IR from dynamic borrowAmount
	 * 
	 */
	
	this.getIRRange = function () {
		
		var cmd = 0;
		
		if (parseInt(loan.borrowAmountValue) >=0 && parseInt(loan.borrowAmountValue) < 3000000){
			cmd = $( '*[data-algoritmInput="salary"]' + salaryActiveClass , loan.activeCalculator).attr( "data-salary-rate-u3" );
		}else if (parseInt(loan.borrowAmountValue) >= 3000000 && parseInt(loan.borrowAmountValue) < 7000000){
			cmd = $( '*[data-algoritmInput="salary"]' + salaryActiveClass , loan.activeCalculator).attr( "data-salary-rate-o3-u7" );
		}else {
			cmd = $( '*[data-algoritmInput="salary"]' + salaryActiveClass , loan.activeCalculator).attr( "data-salary-rate-o7" );
		}
		return cmd;
	}

	/**
	 * Update basket cookie
	 *
	 */
	this.updateBasketCookie = function() {

		var basketButtons = $( "*[data-generate-cookie]" );
		var cmbInput = $( "*[data-cmb-input]" );

		if( basketButtons.length ) {

			var loanConfigurationBasket = basketButtons.attr( "data-c-personalLoanConfiguration" );

		} else {

			var loanConfigurationBasket = '{"LOANAMOUNT": "-","DURATION": "0","INSTALLMENT": "-","DISCOUNTCODE": "-","APR": "0","INTERESTRATE": "0"}';

		}

		// update json object
		var loanConfigurationBasketJSON = JSON.parse( loanConfigurationBasket );
		
		loanConfigurationBasketJSON.APR = loan.salaryAPRValue.toString();
		loanConfigurationBasketJSON.DISCOUNTCODE = loan.salaryInterestRateCode.toString();
//		if(loanConfigurationBasketJSON.DISCOUNTCODE == "" || loanConfigurationBasketJSON.DISCOUNTCODE == "-"){
//			loanConfigurationBasketJSON.DISCOUNTCODE = "NONE";
//		}
		loanConfigurationBasketJSON.DURATION = loan.tenorCalculatedPromo.toString();
		loanConfigurationBasketJSON.INSTALLMENT = loan.monthlyInstallmentValuePromo.toString();
		loanConfigurationBasketJSON.INTERESTRATE = loan.salaryInterestRateValue.toString();
		loanConfigurationBasketJSON.LOANAMOUNT = loan.loanAmountCalculatedPromo.toString();

		if( basketButtons.length ) {

			// update button cookie
			basketButtons.attr( "data-c-personalLoanConfiguration", JSON.stringify( loanConfigurationBasketJSON ) );

		}

		if( cmbInput.length ) {

			// update the input of call me back
			cmbInput.val( JSON.stringify( loanConfigurationBasketJSON ) );

		}

	};

	/**
	 * Toogle shop btn
	 *
	 */
	this.toggleShopBtn = function( btns, action ) {

		btns.each( function( index, element ) {

			var btn = $( element );

			if( btn.hasClass( "sectionNewAccount" ) || btn.hasClass( "sectionNewAccount_hide" ) ) {

				var loginBtn = btn.parent().find( ".sectionLogin" );

				if( action == "hide" ) {

					btn.css( {

						opacity: 0,
						top: "-3000px"

					} );
					btn.removeClass( "sectionNewAccount" ).addClass( "sectionNewAccount_hide" );

					if( loginBtn.length ) {

						loginBtn.css( {

							opacity: 1,
							top: "50%"

						} );

					}

				} else {

					btn.css( {

						opacity: 1,
						top: "50%"

					} );
					btn.removeClass( "sectionNewAccount_hide" ).addClass( "sectionNewAccount" );

					if( loginBtn.length ) {

						loginBtn.css( {

							opacity: 0,
							top: "-3000px"

						} );

					}

				}

			} else {

				if( action == "hide" ) btn.hide();
				else btn.show();

			}

		} );

	};

};

		//check multi calculator
		if (($("html").attr("data-bank") == "VUB" || $("html").attr("data-bank") == "ISPBIH")) {
			$(document).ready(function () {
				if($(".js-loan-filter-hero-btn").length>1){ //marca i diversi filter hero button con un numero
					isMultiButtonPage=true
					console.log("isMultiButtonPage=true "+$(".js-loan-filter-hero-btn").length);
					var filterHeroButton = $(".js-loan-filter-hero-btn").toArray();
					for(var i = 0; i < filterHeroButton.length; i++){
						filterHeroButton[i].classList.add("FHB-"+i);
					}
				}
			});
		}
/**
 * Get class instance
 *
 */
Intesa.LoanCalculator.getInstance = function() {

	if( !window.intesa ) {

		window.intesa = new Object();

	}
	if( !window.intesa.loan_calculator ) {

		window.intesa.loan_calculator = new Intesa.LoanCalculator();

	}

	return window.intesa.loan_calculator;

};
